<script setup>
import ButtonCta from '@/Components/ui/buttons/ButtonCta.vue'
import TextCta from '@/Components/ui/buttons/TextCta.vue'
import InputBox from '@/Components/ui/InputBox.vue'
import { useGetInTouch } from '@/Stores/getintouch'
import { useForm } from '@inertiajs/vue3'
import { useFetchIdle } from '@/Composables/useFetchApi.js'
import { ref, computed } from 'vue'

const nameRef = ref(null)
const emailRef = ref(null)
const messageRef = ref(null)

const getInTouch = useGetInTouch()

const payload = useForm({
	name: '',
	email: '',
	message: '',
})

const isFormInvalid = computed(() => {
	return !payload.name || !payload.email
})

const onSubmit = async () => {
	await useFetchIdle(payload)
}
</script>

<template>
	<div class="w-full">
		<form class="flex gap-2 flex-col" @submit.prevent="onSubmit">
			<InputBox
				key="name-input"
				ref="nameRef"
				v-model="payload.name"
				:disabled="false"
				:error="payload.errors.name"
				:show-label="false"
				class="w-full"
				label-name="Name"
			/>
			<InputBox
				key="email-input"
				ref="emailRef"
				v-model="payload.email"
				:disabled="false"
				:error="payload.errors.email"
				:show-label="false"
				class="w-full"
				label-name="Email"
			/>
			<InputBox
				key="message-input"
				ref="messageRef"
				v-model="payload.message"
				:disabled="false"
				:error="payload.errors.message"
				:show-label="false"
				:max-length="1000"
				class="w-full"
				label-name="Message (optional)"
			/>

			<div class="flex w-full">
				<ButtonCta
					additional-classes="__submit lg:w-full"
					button-mode="dark"
					type="submit"
					:show-loader="getInTouch.getIsLoading"
					:is-disabled="isFormInvalid || getInTouch.getIsLoading"
				>
					<div class="flex items-center font-bold">Submit</div>
				</ButtonCta>
			</div>
		</form>
		<div class="mt-4">
			<p class="text-xs leading-tight">
				By clicking "Submit", you ackowledge that you have read and
				agreed to carbar's
				<TextCta
					href="/terms-and-conditions"
					target="_blank"
					text="terms & conditions"
				/>
				and
				<TextCta
					href="/privacy-policy"
					target="_blank"
					text="privacy policy"
				/>
				<span>.</span>
			</p>
		</div>
	</div>
</template>
